<mat-card>
  <mat-toolbar style="float: left;clear: both;width: 100%;" color="secondary">
    <h3 mat-line style="font-weight: normal;color: black">Usuaris</h3>
    <button *ngIf="userInfo.admin"
      style="margin-left: auto;margin-right: 0" mat-icon-button
      (click)="addNewUser()">
      <mat-icon color="primary" style="font-size: 24px">person_add</mat-icon>
    </button>
  </mat-toolbar>
  <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
  <mat-card-content style="padding: 24px;margin: auto;width: 90%">
    <table>
      <thead>
        <tr>
          <th>Nom</th>
          <th>Càrrec</th>
          <th>Formacions</th>
          <th>Correu</th>
          <th>Telèfon</th>
          <th>Inici</th>          
          <th style="width: 210px;text-align: center">Accions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of userList">
          <td>
            {{user.name}}
          </td>
          <td>
            {{user.carrec}}
          </td>
          <td>
            {{user.formacio}}
          </td>
          <td>
            {{user.email}}
          </td> 
          <td>
            {{user.telefon}}
          </td>  
          <td>
            {{user.data_inici}}
          </td>                           
          <td>
            <mat-button-toggle-group multiple *ngIf="userInfo.admin && false">
              <mat-button-toggle [checked]="user.active" (click)="changeActivity('active', user, !user.active)">Actiu</mat-button-toggle>&nbsp;&nbsp;
              <mat-button-toggle [checked]="user.admin" (click)="changeActivity('admin', user, !user.admin)">Admin</mat-button-toggle>
            </mat-button-toggle-group>
            <span *ngIf="!userInfo.admin">{{(user.active ? 'Actiu' : 'Inactiu')}}</span>
            <button mat-icon-button matTooltip="Edita" aria-label="Edita" matTooltipClass="tooltip-style" color="primary"
              *ngIf="userInfo.admin || userInfo.email === user.email"
              (click)="editUser(user)"
              style="width:30px">
              <mat-icon color="primary" style="font-size:24px">mode_edit</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Esborra" aria-label="Esborra" matTooltipClass="tooltip-style" color="primary"
              *ngIf="userInfo.admin"
              (click)="deleteUser(user)" style="width:30px">
              <mat-icon color="primary" style="font-size:24px">delete_forever</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Modificar el currículum" aria-label="Modificar el currículum" matTooltipClass="tooltip-style" color="primary" *ngIf="userInfo.admin || userInfo.email === user.email || canReport()"
              (click)="curriculum(user)" style="width:30px">
              <mat-icon color="primary" style="font-size:24px">person_pin</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Mostrar el currículum de l'usuari" aria-label="Mostrar el currículum" matTooltipClass="tooltip-style" color="primary" style="width:30px" (click)="curriculumV(user.id)">
               <!--<a href="https://datastudio.google.com/s/uMC1oQ7-FNI?filter=personal_curriculum/id_personal eq '{{user.id}}'" target="_blank"> -->
              <mat-icon color="primary" style="font-size:24px">visibility</mat-icon>
            <!--</a> -->
            </button>
            <button mat-icon-button matTooltip="Editar el calendari" aria-label="Editar el calendari" matTooltipClass="tooltip-style"  color="primary" *ngIf="userInfo.admin || userInfo.email === user.email || canReport()"
              (click)="calendari(user)" style="width:30px">
              <mat-icon color="primary" style="font-size:24px">nature</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Anar al treballs de l'usuari" aria-label="Anar al treballs de l'usuari" matTooltipClass="tooltip-style" color="primary"
              (click)="treballs(user.id)" style="width:30px">
              <mat-icon color="primary" style="font-size:24px">folder</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>

<dialog *ngIf="showDialog" open>
 <mat-card-content>
  <form (submit)="addOrUpdateUser($event)">
    <h3>Dades d'autenticació</h3>
    <div>
     <mat-form-field>
      <input matInput style="width: 100%" [disabled]="editUserData.ID !== 'NEW'"
        placeholder="E-mail" name="email" type="email" required
        [(ngModel)]="editUserData.email" ngDefaultControl
      />
     </mat-form-field> 
     <mat-form-field> 
      <input matInput style="width: 100%"
        placeholder="Nom" name="name" required
        [(ngModel)]="editUserData.name" ngDefaultControl
      />
     </mat-form-field> 
    </div>
    <div>
      <mat-form-field>
       <input matInput 
        placeholder="Clau" name="password" (change)="validateEqualPassword($event)" type="password"
        [(ngModel)]="editUserData.password" ngDefaultControl
        #password1
       />
      </mat-form-field> 
      <mat-form-field>
       <input matInput 
        placeholder="Repeteix clau" name="repeatPassword" (change)="validateEqualPassword($event)" type="password"
        [(ngModel)]="editUserData.repeatPassword" ngDefaultControl
        #password2
       />
      </mat-form-field> 
    </div>
    <h3>Dades personals</h3>
    <div>
      <div>
       <mat-form-field>
        <input matInput [disabled]="editUserData.ID !== 'NEW'"
          placeholder="Persona (Id projectes)" required name="PERSONA" style="min-width: 45%;"
          [(ngModel)]="editUserData.id" ngDefaultControl
        />
       </mat-form-field> 
       <mat-form-field> 
        <input matInput 
          placeholder="Telèfon" type="phone" name="phone" style="min-width: 45%;"
          [(ngModel)]="editUserData.telefon" ngDefaultControl
        />
       </mat-form-field> 
      </div>
      <div>
       <mat-form-field> 
        <input matInput 
          placeholder="Experiència" name="anys_experiencia"
          [(ngModel)]="editUserData.anys_experiencia" ngDefaultControl
        />
       </mat-form-field> 
       <mat-form-field> 
        <input matInput 
          placeholder="Data inici" name="data_inici" type="date"
          [(ngModel)]="editUserData.data_inici" ngDefaultControl
        />
       </mat-form-field> 
       <mat-form-field> 
        <input matInput 
          placeholder="Data fi" name="data_fi" type="date"
          [(ngModel)]="editUserData.data_fi" ngDefaultControl
        />
       </mat-form-field>
      </div>
      <div>
       <mat-form-field style="width: 100%">
        <input matInput  style="width: 100%"
          placeholder="Formació (separades per ';' afegir any finalització)" name="formacio" [(ngModel)]="editUserData.formacio" ngDefaultControl
        />
      </mat-form-field> 
      </div>
      <div>
       <mat-form-field>
        <input matInput  style="width: 100%;"
          placeholder="Càrrec" name="carrec"
          [(ngModel)]="editUserData.carrec" ngDefaultControl
        />
       </mat-form-field> 
      </div>      
    </div>
    <div style="padding-top: 2em; text-align: right;">
      <button mat-button type="submit" style="margin-left: auto; margin-right: 1em;">
        Desa
      </button>
      <button mat-button (click)="showDialog = !showDialog">
        Tanca
      </button>
   </div>
  </form>
  </mat-card-content>
</dialog>